module.exports = __webpack_public_path__ + "static/media/1.bef1b429.jpg";